/*
  Panafargo — carrusel de las vitrinas de categorías (category-showcase y
  category-subcategories). Antes cada sección traía su propia copia idéntica.
  Cada tipo se reconoce por su prefijo de clases (<prefijo>__carousel, __track,
  __dots, __dot, __nav). El autoplay se pausa fuera de pantalla y con la pestaña
  oculta (no gasta trabajo mientras nadie lo ve).
*/
const TYPES = [
  { prefix: 'cat-showcase', dotLabel: 'Ir al producto' },
  { prefix: 'cat-subcats', dotLabel: 'Ir a la subcategoría' },
];

const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

class PfCarousel {
  constructor(el, { prefix, dotLabel }) {
    this.el = el;
    this.prefix = prefix;
    this.dotLabel = dotLabel;
    this.track = el.querySelector(`.${prefix}__track`);
    this.dotsWrap = el.querySelector(`.${prefix}__dots`);
    if (!this.track) return;
    this.slides = Array.from(this.track.children);
    this.interval = parseInt(el.dataset.autoplay, 10) || 0;
    this.index = 0;
    this.timer = null;
    this.hovered = false;
    this.visible = false;
    this.buildDots();
    this.bind();
  }

  buildDots() {
    if (!this.dotsWrap || this.slides.length < 2) return;
    this.slides.forEach((_, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = `${this.prefix}__dot`;
      b.setAttribute('aria-label', `${this.dotLabel} ${i + 1}`);
      b.addEventListener('click', () => this.go(i, true));
      this.dotsWrap.appendChild(b);
    });
    this.dots = Array.from(this.dotsWrap.children);
    this.updateDots();
  }

  bind() {
    this.el.querySelectorAll(`.${this.prefix}__nav`).forEach((btn) => {
      btn.addEventListener('click', () => this.go(this.index + parseInt(btn.dataset.dir, 10), true));
    });
    let t;
    this.track.addEventListener(
      'scroll',
      () => {
        clearTimeout(t);
        t = setTimeout(() => {
          const w = this.track.clientWidth || 1;
          this.index = Math.round(this.track.scrollLeft / w);
          this.updateDots();
        }, 90);
      },
      { passive: true }
    );
    const pause = () => {
      this.hovered = true;
      this.sync();
    };
    const resume = () => {
      this.hovered = false;
      this.sync();
    };
    this.el.addEventListener('mouseenter', pause);
    this.el.addEventListener('mouseleave', resume);
    this.el.addEventListener('focusin', pause);
    this.el.addEventListener('focusout', resume);

    new IntersectionObserver(([entry]) => {
      this.visible = entry.isIntersecting;
      this.sync();
    }).observe(this.el);
    document.addEventListener('visibilitychange', () => this.sync());
  }

  go(i, user) {
    const n = this.slides.length;
    if (!n) return;
    this.index = ((i % n) + n) % n;
    this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: 'smooth' });
    this.updateDots();
    if (user) {
      this.stopAuto();
      this.sync();
    }
  }

  updateDots() {
    if (!this.dots) return;
    this.dots.forEach((d, i) => d.setAttribute('aria-current', i === this.index ? 'true' : 'false'));
  }

  // Autoplay solo si está en pantalla, pestaña visible, sin hover/foco y sin "reducir movimiento".
  sync() {
    const shouldRun =
      this.interval && this.slides.length > 1 && this.visible && !this.hovered && !document.hidden && !reducedMotion.matches;
    if (shouldRun && !this.timer) {
      this.timer = setInterval(() => this.go(this.index + 1), this.interval);
    } else if (!shouldRun) {
      this.stopAuto();
    }
  }

  stopAuto() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }
}

function init(root = document) {
  for (const type of TYPES) {
    root.querySelectorAll(`.${type.prefix}__carousel`).forEach((el) => {
      if (!el.__pfCarousel) el.__pfCarousel = new PfCarousel(el, type);
    });
  }
}

init();
document.addEventListener('shopify:section:load', (e) => init(e.target));
